"use client";

import React, { useState } from "react";
import { DocumentDetails } from "@/components/documents/cards/document-details-card";
import { DocumentList } from "@/components/documents/cards/document-list";
import { DocumentUpload } from "@/components/documents/cards/document-upload-card";

export function DocumentsTab() {
  const [activeSection, setActiveSection] = useState("list");

  return (
    <div className="">
      {activeSection === "list" && (
        <DocumentList
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
      )}

      {activeSection === "upload" && (
        <DocumentUpload
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
      )}

      {activeSection === "details" && (
        <DocumentDetails
          activeSection={activeSection}
          setActiveSection={setActiveSection}
        />
      )}
    </div>
  );
}
